import { v4 as uuidv4 } from 'uuid'
import Destination from '@web-ui-kit/destination'
import Tooltip from '@web-ui-kit/tooltip'
import Text from '@web-ui-kit/text'
import useNavigationOptions from '../../hooks/useNavigationOptions'
import * as Sc from './BottomNav.style'

const BottomNav = () => {
  const { mainOptions } = useNavigationOptions()
  return (
    <Sc.Container aria-label='bottom-nav'>
      {mainOptions.map((option) =>
        option.tooltip ? (
          <Tooltip
            align='center'
            element={
              <Destination
                active={option?.active}
                dataTestId={option?.dataTestId}
                disabled={option?.disabled}
                icon={option.icon}
                id={option?.id}
                onClick={option.onClick}
              />
            }
            id={`tooltip-${option?.id}`}
            key={option?.id ?? uuidv4()}
            position='top'
          >
            <Text variant='small'>{option.tooltip}</Text>
          </Tooltip>
        ) : (
          <Destination
            active={option?.active}
            dataTestId={option?.dataTestId}
            disabled={option?.disabled}
            icon={option.icon}
            id={option?.id}
            key={option?.id ?? uuidv4()}
            onClick={option.onClick}
          />
        )
      )}
    </Sc.Container>
  )
}

export default BottomNav
